import * as React from "react";
import ScaffoldTitle from "./Scaffold/components/ScaffoldTitle";
import Scaffold from "./Scaffold/Scaffold";

interface GenericSettingsScreenProps {
  title: string;
  onClickGoBack: () => void;
}

const GenericSettingsScreen = (props: React.PropsWithChildren<GenericSettingsScreenProps>) => {
  return (
    <Scaffold
      title={<ScaffoldTitle label={props.title} />}
      className="GenericSettingsScreen"
      onClickGoBack={props.onClickGoBack}
    >
      {props.children}
    </Scaffold>
  );
};

export default React.memo(GenericSettingsScreen);
